import React, { useReducer, useEffect } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import Filters from './Filters';
import { makeStyles } from '@material-ui/core/styles';
import { isMobile } from 'react-device-detect';
import { Divider } from '@material-ui/core';
import { initialState, reducer, store } from './reducer';
import { store as mainStore } from '../../../../../store';
import List from './List';
import axios from '../../../../../api/axios';
import useTitle from 'hooks/useTitle';
import PreviuseList from './PreviuseList';
import { useCalculation } from 'useStores/useCalculation';
import { useMainStore } from 'useStores/useMainStore';
import useToast from 'hooks/useToast';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : '1fr',
    gridGap: theme.spacing(1),
  },
}));

const BasePrice = () => {
  useTitle('محاسبه کرایه حمل');
  const classes = useStyles();
  const toast = useToast();

  const limit = useMainStore((state) => state.limit);
  const previusePage = useCalculation((state) => state.page);
  const origin = useCalculation((state) => state.filters.origin);
  const destination = useCalculation((state) => state.filters.destination);
  const fleetOptions = useCalculation((state) => state.filters.fleetOptions);
  const fromDate = useCalculation((state) => state.filters.fromDate);
  const toDate = useCalculation((state) => state.filters.toDate);
  const page = useCalculation((state) => state.basePrice.page);
  const progress = useCalculation((state) => state.filters.progress);
  const setProgress = useCalculation((state) => state.setProgress);

  const orders = useCalculation((state) => state.basePrice.order);
  const setOrders = useCalculation((state) => state.setOrders);

  const previousOrder = useCalculation(
    (state) => state.basePrice.previousOrder
  );
  const setPreviuseOrders = useCalculation((state) => state.setPreviuseOrders);

  const isPreviuseOrders = useCalculation(
    (state) => state.filters.isPreviuseOrders
  );
  const setPreviuseOrdersAvgPrice = useCalculation(
    (state) => state.setPreviuseOrdersAvgPrice
  );

  const actions = {
    fetchOrders: async () => {
      try {
        setProgress(true);
        const { data } = await axios.post(`/api/v1/admin/calculations/order`, {
          origin: origin?.value,
          destination: destination?.value,
          fleetOptions: fleetOptions?.map((fl) => fl._id),
          fromDate,
          toDate,
          page,
          limit: limit,
        });
        if (data?.ok) setOrders(data);
      } catch (error) {
        toast.showError(error);
      } finally {
        setProgress(false);
      }
    },
    fetchPreviuseOrders: async () => {
      try {
        setProgress(true);
        const { data } = await axios.post(
          `/api/v1/admin/baseprices/listBetweenDates`,
          {
            origin: origin?.value,
            destination: destination?.value,
            fleetOptions: fleetOptions?.map((fl) => fl._id),
            start: fromDate,
            end: toDate,
            page: previusePage,
            limit: limit,
          }
        );
        if (data?.ok) {
          setPreviuseOrders(data);
          setPreviuseOrdersAvgPrice(data.basePriceAverage);
        }
      } catch (error) {
        toast.showError(error);
      } finally {
        setProgress(false);
      }
    },
  };
  const refreshList = () => {
    actions.fetchOrders();
  };
  const refreshPreviuseList = () => {
    actions.fetchPreviuseOrders();
  };

  useEffect(() => {
    if (origin && destination && isPreviuseOrders) {
      refreshList();
    } else if (origin && destination && !isPreviuseOrders) {
      refreshPreviuseList();
    }
  }, [
    origin,
    destination,
    fleetOptions,
    fromDate,
    toDate,
    page,
    limit,
    isPreviuseOrders,
  ]);

  return (
    <FullCard title="محاسبه کرایه حمل">
      <div className={classes.root}>
        <Filters />
        <Divider />
        {isPreviuseOrders ? <List /> : <PreviuseList />}
      </div>
    </FullCard>
  );
};

export default React.memo(BasePrice);
